export enum ATTENDANCE_STATUS {
  VERIFIED = 'VERIFIED',
  UNVERIFIED = 'UNVERIFIED',
  PENDING = 'PENDING',
}

export enum AUTHORIZER_STATUS {
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
}

export enum ATTENDANCE_SOURCE {
  LAUNCHPAD = 'Launchpad',
  FINGERPRINT = 'Fingerprint',
}

export enum ATTENDANCE_LOCATION {
  HOME = 'Home',
  OFFICE = 'Office',
}

export enum FILE_FIELD_VALIDATION_ERROR_TYPES {
  REQUIRED = 'REQUIRED',
  UNIQUE = 'UNIQUE',
  TYPE_MISMATCH = 'TYPE_MISMATCH',
}
